(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9755],{

/***/ 70817:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Fj": function() { return /* binding */ mapBoardWithAvailabilityTotals; },
/* harmony export */   "bB": function() { return /* binding */ mapBoardCollectionToPriceData; },
/* harmony export */   "iO": function() { return /* binding */ mapBoardToPriceData; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50930);



function mapBoardToPriceData(param) {
    var additionalFees = param.additionalFees, bighead = param.bighead, bigheadCurrency = param.bigheadCurrency, cancellationFrom = param.cancellationFrom, insurance = param.insurance, pdp = param.pdp, isMobile = param.isMobile, isPrime = param.isPrime, nights = param.nights, paymentPolicy = param.paymentPolicy, _payRate = param.payRate, payRate = _payRate === void 0 ? 0 : _payRate, roomName = param.roomName, roomsNumber = param.roomsNumber, sellingRate = param.sellingRate, sellingRateCurrency = param.sellingRateCurrency, staywallet = param.staywallet, staywalletCurrency = param.staywalletCurrency, subtotal = param.subtotal, subtotalCurrency = param.subtotalCurrency, pricePerNightSubtotal = param.pricePerNightSubtotal, pricePerNightSubtotalCurrency = param.pricePerNightSubtotalCurrency, taxes = param.taxes, taxesCurrency = param.taxesCurrency, total = param.total, totalCurrency = param.totalCurrency, totalWithFees = param.totalWithFees, totalWithFeesCurrency = param.totalWithFeesCurrency, pricePerNightWithFees = param.pricePerNightWithFees, pricePerNightWithFeesCurrency = param.pricePerNightWithFeesCurrency;
    return {
        additionalFees: additionalFees,
        bighead: bighead,
        bigheadCurrency: bigheadCurrency,
        insurance: insurance === null || insurance === void 0 ? void 0 : insurance.amount,
        insuranceCurrency: insurance === null || insurance === void 0 ? void 0 : insurance.currency,
        pdp: pdp === null || pdp === void 0 ? void 0 : pdp.amount,
        pdpCurrency: pdp === null || pdp === void 0 ? void 0 : pdp.currency,
        isMobile: isMobile || false,
        isPrime: isPrime || false,
        nights: nights,
        payDate: cancellationFrom,
        payLate: payRate ? total - payRate : null,
        paymentPolicy: paymentPolicy,
        payNow: payRate,
        roomsBooked: "".concat(roomsNumber, " x ").concat(roomName),
        roomsNumber: roomsNumber,
        sellingRate: sellingRate,
        sellingRateCurrency: sellingRateCurrency,
        staywallet: staywallet,
        staywalletCurrency: staywalletCurrency,
        subtotal: subtotal,
        subtotalCurrency: subtotalCurrency,
        pricePerNightSubtotal: pricePerNightSubtotal,
        pricePerNightSubtotalCurrency: pricePerNightSubtotalCurrency,
        taxes: taxes,
        taxesCurrency: taxesCurrency,
        total: total,
        totalCurrency: totalCurrency,
        totalWithFees: totalWithFees,
        totalWithFeesCurrency: totalWithFeesCurrency,
        pricePerNightWithFees: pricePerNightWithFees,
        pricePerNightWithFeesCurrency: pricePerNightWithFeesCurrency
    };
}
function mapBoardCollectionToPriceData() {
    var boards = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], totals = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var priceDataCollection = boards.map(function(board) {
        return mapBoardToPriceData((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, board), {
            insurance: null
        }));
    });
    var priceData = priceDataCollection.reduce(function(totalPriceData, currentPriceData) {
        if (!totalPriceData) {
            return currentPriceData;
        }
        var bighead = totalPriceData.bighead + currentPriceData.bighead;
        var sellingRate = totalPriceData.sellingRate + currentPriceData.sellingRate;
        var roomsBooked = "".concat(totalPriceData.roomsBooked, "\n").concat(currentPriceData.roomsBooked, "\n");
        var total = totalPriceData.total + currentPriceData.total;
        var subtotal = totalPriceData.subtotal + currentPriceData.subtotal;
        var payNow = totalPriceData.payNow + currentPriceData.payNow;
        var payLate = totalPriceData.payLate + currentPriceData.payLate;
        var taxes = totalPriceData.taxes + currentPriceData.taxes;
        var isPrime = currentPriceData.isPrime || totalPriceData.isPrime;
        var totalWithFees = totalPriceData.totalWithFees + currentPriceData.totalWithFees;
        var additionalFees = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(totalPriceData.additionalFees).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(currentPriceData.additionalFees));
        var roomsNumber = totalPriceData.roomsNumber + currentPriceData.roomsNumber;
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, totalPriceData, currentPriceData), {
            bighead: bighead,
            isPrime: isPrime,
            roomsBooked: roomsBooked,
            sellingRate: sellingRate,
            total: total,
            subtotal: subtotal,
            payNow: payNow,
            payLate: payLate,
            taxes: taxes,
            totalWithFees: totalWithFees,
            additionalFees: additionalFees,
            roomsNumber: roomsNumber
        });
    });
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, priceData, totals);
}
var mapBoardWithAvailabilityTotals = function(board, availabilityTotals) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, board, availabilityTotals === null || availabilityTotals === void 0 ? void 0 : availabilityTotals.find(function(param) {
        var availabilityId = param.availabilityId;
        return availabilityId === board.availabilityId;
    }));
};


/***/ }),

/***/ 60644:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47842);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(70865);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var src_hooks_usePrices__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83310);
/* harmony import */ var src_types_prices__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55806);
/* harmony import */ var client_components_PriceDetails__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96540);
/* harmony import */ var client_components_PriceDetailsRefined__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47163);








var _obj;
var PriceDetailsMap = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, src_types_prices__WEBPACK_IMPORTED_MODULE_3__/* .PriceType.Net */ .F.Net, client_components_PriceDetails__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, src_types_prices__WEBPACK_IMPORTED_MODULE_3__/* .PriceType.Gross */ .F.Gross, client_components_PriceDetails__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, src_types_prices__WEBPACK_IMPORTED_MODULE_3__/* .PriceType.TrivagoNet */ .F.TrivagoNet, client_components_PriceDetails__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, src_types_prices__WEBPACK_IMPORTED_MODULE_3__/* .PriceType.AllIn */ .F.AllIn, client_components_PriceDetailsRefined__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, src_types_prices__WEBPACK_IMPORTED_MODULE_3__/* .PriceType.AllInDaily */ .F.AllInDaily, client_components_PriceDetailsRefined__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, src_types_prices__WEBPACK_IMPORTED_MODULE_3__/* .PriceType.NetWithFees */ .F.NetWithFees, client_components_PriceDetailsRefined__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, src_types_prices__WEBPACK_IMPORTED_MODULE_3__/* .PriceType.NetWithFeesDaily */ .F.NetWithFeesDaily, client_components_PriceDetailsRefined__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z), _obj);
var PriceDetailsFactory = function(props) {
    var priceType = (0,src_hooks_usePrices__WEBPACK_IMPORTED_MODULE_2__/* .usePrices */ .h)({
        rooms: []
    }).priceType;
    var PriceDetailsComponent = PriceDetailsMap[priceType];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PriceDetailsComponent, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, props));
};
/* harmony default export */ __webpack_exports__["Z"] = (PriceDetailsFactory);


/***/ }),

/***/ 47163:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ LineTotalPriceRefined; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(83112);
/* harmony import */ var _PriceDetails_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(60944);
/* harmony import */ var src_comps_CheckoutWalletSelector__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(40401);
/* harmony import */ var client_components_Price__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(50992);
/* harmony import */ var src_comps_MessageBox__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(14686);
/* harmony import */ var _PriceDetails_TravelInsuranceLine__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(30880);
/* harmony import */ var _PriceDetails_styles__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(43854);
/* harmony import */ var _PriceDetails__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(96540);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(3854);
/* eslint-disable react/no-array-index-key */ 
function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}











var LineRoom = function(param) {
    var nights = param.nights, roomsNumber = param.roomsNumber, subtotal = param.subtotal, subtotalCurrency = param.subtotalCurrency;
    var intl = (0,react_intl__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)();
    var valueNights = {
        nights: nights,
        rooms: roomsNumber
    };
    var valuePricePerNighs = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        return {
            price: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(client_components_Price__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                amount: Math.round(subtotal / nights),
                currency: subtotalCurrency
            })
        };
    }, [
        nights,
        subtotal,
        subtotalCurrency
    ]);
    var roomsKey = roomsNumber > 1 ? "global.rooms" : "global.room";
    return nights ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_PriceDetails_styles__WEBPACK_IMPORTED_MODULE_8__/* .Line */ .x1, {
        "data-testid": "subtotal",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_PriceDetails_styles__WEBPACK_IMPORTED_MODULE_8__/* .LineRoomResume */ .RG, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("p", {
                        children: [
                            roomsNumber,
                            " ",
                            intl.formatMessage({
                                id: roomsKey
                            }),
                            " x",
                            " ",
                            intl.formatMessage({
                                id: "global.nights"
                            }, valueNights)
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                        children: intl.formatMessage({
                            id: "global.price-night"
                        }, valuePricePerNighs)
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_PriceDetails_styles__WEBPACK_IMPORTED_MODULE_8__/* .Amount */ .$d, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(client_components_Price__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    amount: subtotal,
                    currency: subtotalCurrency
                })
            })
        ]
    }) : null;
};
var LineTotalPriceRefined = (0,styled_components__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP)(_PriceDetails__WEBPACK_IMPORTED_MODULE_9__/* .LineTotalPrice */ .Zi).withConfig({
    displayName: "PriceDetailsRefined__LineTotalPriceRefined",
    componentId: "sc-70edd44a-0"
})(_templateObject());
var PriceDetailsRefined = function(param) {
    var additionalFees = param.additionalFees, additionalProducts = param.additionalProducts, insurance = param.insurance, insuranceCurrency = param.insuranceCurrency, pdp = param.pdp, pdpCurrency = param.pdpCurrency, isVoucher = param.isVoucher, nights = param.nights, payDate = param.payDate, payLate = param.payLate, payNow = param.payNow, purchaseId = param.purchaseId, roomsNumber = param.roomsNumber, sellingRateCurrency = param.sellingRateCurrency, _showPaymentDates = param.showPaymentDates, showPaymentDates = _showPaymentDates === void 0 ? true : _showPaymentDates, showWalletCheckbox = param.showWalletCheckbox, staywallet = param.staywallet, staywalletCurrency = param.staywalletCurrency, subtotal = param.subtotal, subtotalCurrency = param.subtotalCurrency, taxes = param.taxes, taxesCurrency = param.taxesCurrency, total = param.total, totalCurrency = param.totalCurrency, totalWithFees = param.totalWithFees, variant = param.variant;
    var intl = (0,react_intl__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)();
    var dateText = intl.formatDate(payDate, {
        year: "numeric",
        month: "long",
        day: "2-digit"
    });
    var valuePayDate = {
        date: dateText
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_PriceDetails_styles__WEBPACK_IMPORTED_MODULE_8__/* .PriceDetailsBase */ .Sv, {
        "data-testid": "price-details-refined",
        children: [
            variant !== _PriceDetails_constants__WEBPACK_IMPORTED_MODULE_3__/* .VARIANT_SIMPLE */ .R && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_PriceDetails_styles__WEBPACK_IMPORTED_MODULE_8__/* .Title */ .Dx, {
                children: intl.formatMessage({
                    id: isVoucher ? "global.price" : "global.price-breakdown"
                })
            }),
            showWalletCheckbox && purchaseId && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_comps_CheckoutWalletSelector__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                purchaseId: purchaseId
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(LineRoom, {
                roomsNumber: roomsNumber,
                nights: nights,
                subtotal: subtotal,
                subtotalCurrency: subtotalCurrency
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_PriceDetails__WEBPACK_IMPORTED_MODULE_9__/* .LineTaxes */ .hz, {
                taxes: taxes,
                taxesCurrency: taxesCurrency
            }),
            !isVoucher ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_PriceDetails__WEBPACK_IMPORTED_MODULE_9__/* .LineAdditionalFees */ .ce, {
                additionalFees: additionalFees,
                isVoucher: isVoucher
            }) : null,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_PriceDetails__WEBPACK_IMPORTED_MODULE_9__/* .LineStaywallet */ .DH, {
                staywallet: staywallet,
                staywalletCurrency: staywalletCurrency,
                variant: variant
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_PriceDetails_TravelInsuranceLine__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                currency: totalCurrency,
                additionalProducts: additionalProducts
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_PriceDetails__WEBPACK_IMPORTED_MODULE_9__/* .LineInsurance */ .T4, {
                insurance: insurance,
                insuranceCurrency: insuranceCurrency,
                variant: variant
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_PriceDetails__WEBPACK_IMPORTED_MODULE_9__/* .LinePriceDropProtect */ .yf, {
                pdp: pdp,
                pdpCurrency: pdpCurrency,
                variant: variant
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(LineTotalPriceRefined, {
                total: totalWithFees !== null && totalWithFees !== void 0 ? totalWithFees : total,
                totalCurrency: totalCurrency
            }),
            isVoucher ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_PriceDetails__WEBPACK_IMPORTED_MODULE_9__/* .LineAdditionalFees */ .ce, {
                additionalFees: additionalFees,
                isVoucher: isVoucher
            }) : null,
            variant !== _PriceDetails_constants__WEBPACK_IMPORTED_MODULE_3__/* .VARIANT_SIMPLE */ .R && payNow >= 0 && payNow !== (totalWithFees !== null && totalWithFees !== void 0 ? totalWithFees : total) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_PriceDetails_styles__WEBPACK_IMPORTED_MODULE_8__/* .Line */ .x1, {
                variant: "pay",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                        children: intl.formatMessage({
                            id: "global.now-pay"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_PriceDetails_styles__WEBPACK_IMPORTED_MODULE_8__/* .Amount */ .$d, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(client_components_Price__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                            amount: payNow,
                            currency: sellingRateCurrency
                        })
                    })
                ]
            }) : null,
            variant !== _PriceDetails_constants__WEBPACK_IMPORTED_MODULE_3__/* .VARIANT_SIMPLE */ .R && showPaymentDates && payLate && payDate ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_PriceDetails_styles__WEBPACK_IMPORTED_MODULE_8__/* .Line */ .x1, {
                variant: "pay",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                        children: intl.formatMessage({
                            id: "global.you-will-pay"
                        }, valuePayDate)
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_PriceDetails_styles__WEBPACK_IMPORTED_MODULE_8__/* .Amount */ .$d, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(client_components_Price__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                            amount: payLate,
                            currency: sellingRateCurrency
                        })
                    })
                ]
            }) : null,
            variant !== _PriceDetails_constants__WEBPACK_IMPORTED_MODULE_3__/* .VARIANT_SIMPLE */ .R ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_PriceDetails__WEBPACK_IMPORTED_MODULE_9__/* .LineAdditionalFees */ .ce, {
                additionalFees: additionalFees,
                isVoucher: isVoucher,
                simple: true
            }) : null,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_comps_MessageBox__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                message: intl.formatMessage({
                    id: "global.currency-charge"
                }),
                type: "info"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PriceDetailsRefined);


/***/ }),

/***/ 78962:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var client_icons_Info__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3802);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16126);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_3__);




var InfoButton = function(param) {
    var handleClick = param.handleClick;
    return handleClick ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        type: "button",
        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().info),
        onClick: handleClick,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(client_icons_Info__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            size: 12
        })
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().info),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(client_icons_Info__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            size: 12
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (InfoButton);


/***/ }),

/***/ 24509:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ OfferResponsive_OfferConditions; }
});

// UNUSED EXPORTS: ROOM_ONLY_CODE, Rate

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../packages/ds/src/index.ts + 107 modules
var src = __webpack_require__(52134);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(12524);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./client/icons/MobilePhone.js
var MobilePhone = __webpack_require__(68436);
// EXTERNAL MODULE: ../../node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(83112);
// EXTERNAL MODULE: ./src/hooks/useDevice/index.ts
var useDevice = __webpack_require__(72731);
// EXTERNAL MODULE: ./src/types/device.ts
var types_device = __webpack_require__(68686);
// EXTERNAL MODULE: ./client/icons/Fire.js
var Fire = __webpack_require__(54332);
// EXTERNAL MODULE: ./client/icons/Rocket.js
var Rocket = __webpack_require__(85536);
// EXTERNAL MODULE: ./client/components/Rooms/RoomResponsive/BestPropertyTag/styles.module.css
var styles_module = __webpack_require__(74890);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./client/components/Rooms/RoomResponsive/BestPropertyTag/index.tsx







var getIcon = function(branded) {
    if (branded) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Rocket/* default */.Z, {
            size: 12
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Fire/* default */.Z, {
        size: 12
    });
};
var BestPropertyTag = function(param) {
    var copy = param.copy, _branded = param.branded, branded = _branded === void 0 ? false : _branded;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((styles_module_default()).bestPropertyTag, (0,_define_property/* default */.Z)({}, (styles_module_default()).branded, branded)),
        children: [
            getIcon(branded),
            copy
        ]
    });
};
/* harmony default export */ var RoomResponsive_BestPropertyTag = (BestPropertyTag);

// EXTERNAL MODULE: ./client/components/Rooms/RoomResponsive/InfoButton/index.tsx
var InfoButton = __webpack_require__(78962);
// EXTERNAL MODULE: ./client/components/Rooms/RoomResponsive/OfferResponsive/Board/index.tsx
var Board = __webpack_require__(57058);
;// CONCATENATED MODULE: ./client/components/Rooms/RoomResponsive/OfferResponsive/Board/BoardDescription/index.tsx




var BoardDescription = function(param) {
    var code = param.code;
    var intl = (0,useIntl/* default */.Z)();
    var item = Board/* codeBoardMap.get */.Un.get(code);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: (item === null || item === void 0 ? void 0 : item.description) ? intl.formatMessage({
            id: item.description
        }) : null
    });
};
/* harmony default export */ var Board_BoardDescription = (BoardDescription);

// EXTERNAL MODULE: ./client/components/Rooms/RoomResponsive/OfferResponsive/Board/BoardIcon/index.tsx
var BoardIcon = __webpack_require__(76855);
;// CONCATENATED MODULE: ./client/components/Rooms/RoomResponsive/OfferResponsive/Board/BoardName/index.tsx




var BoardName = function(param) {
    var code = param.code, name = param.name;
    var intl = (0,useIntl/* default */.Z)();
    if (Board/* codeBoardMap.has */.Un.has(code)) {
        var item = Board/* codeBoardMap.get */.Un.get(code);
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: intl.formatMessage({
                id: item === null || item === void 0 ? void 0 : item.name
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: name
    });
};
/* harmony default export */ var Board_BoardName = (BoardName);

// EXTERNAL MODULE: ./client/components/Rooms/RoomResponsive/OfferResponsive/OfferConditions/RateNOR/index.tsx
var RateNOR = __webpack_require__(14346);
// EXTERNAL MODULE: ./client/components/Rooms/RoomResponsive/OfferResponsive/OfferConditions/RateNRF/index.tsx
var RateNRF = __webpack_require__(58112);
// EXTERNAL MODULE: ./client/components/Rooms/RoomResponsive/OfferResponsive/OfferConditions/RateSFL/index.tsx
var RateSFL = __webpack_require__(26613);
// EXTERNAL MODULE: ./client/components/Rooms/RoomResponsive/OfferResponsive/OfferConditions/styles.module.css
var OfferConditions_styles_module = __webpack_require__(80646);
var OfferConditions_styles_module_default = /*#__PURE__*/__webpack_require__.n(OfferConditions_styles_module);
;// CONCATENATED MODULE: ./client/components/Rooms/RoomResponsive/OfferResponsive/OfferConditions/index.tsx



















var Rate;
(function(Rate) {
    Rate["NOR"] = "NOR";
    Rate["SFL"] = "SFL";
    Rate["NRF"] = "NRF";
})(Rate || (Rate = {}));
var ROOM_ONLY_CODE = "RO";
var _obj;
var rates = (_obj = {}, (0,_define_property/* default */.Z)(_obj, Rate.NOR, RateNOR/* default */.ZP), (0,_define_property/* default */.Z)(_obj, Rate.NRF, RateNRF/* default */.ZP), (0,_define_property/* default */.Z)(_obj, Rate.SFL, RateSFL/* default */.ZP), _obj);
var _obj1;
var ratesPaymentDescription = (_obj1 = {}, (0,_define_property/* default */.Z)(_obj1, Rate.NOR, RateNOR/* RateNORPaymentDescription */.Y$), (0,_define_property/* default */.Z)(_obj1, Rate.NRF, RateNRF/* RateNRFPaymentDescription */.Nm), (0,_define_property/* default */.Z)(_obj1, Rate.SFL, RateSFL/* RateSFLPaymentDescription */.mN), _obj1);
var _obj2;
var ratesCancellationDescription = (_obj2 = {}, (0,_define_property/* default */.Z)(_obj2, Rate.NOR, RateNOR/* RateNORCancellationDescription */.f3), (0,_define_property/* default */.Z)(_obj2, Rate.NRF, RateNRF/* RateNRFCancellationDescription */.Os), (0,_define_property/* default */.Z)(_obj2, Rate.SFL, RateSFL/* RateSFLCancellationDescription */.Kt), _obj2);
var getBestPropertyTag = function(paymentPolicy, bestPrice, intl) {
    return paymentPolicy === Rate.SFL ? /*#__PURE__*/ (0,jsx_runtime.jsx)(RoomResponsive_BestPropertyTag, {
        branded: true,
        copy: intl.formatMessage({
            id: "policies.best-deal"
        })
    }) : bestPrice && /*#__PURE__*/ (0,jsx_runtime.jsx)(RoomResponsive_BestPropertyTag, {
        copy: intl.formatMessage({
            id: "global.best-price"
        })
    });
};
var OfferConditions = function(param) {
    var code = param.code, currency = param.currency, _name = param.name, name = _name === void 0 ? "" : _name, cancellation = param.cancellation, _isMobile = param.isMobile, isMobile = _isMobile === void 0 ? false : _isMobile, paymentPolicy = param.paymentPolicy, payRate = param.payRate, _bestPrice = param.bestPrice, bestPrice = _bestPrice === void 0 ? false : _bestPrice;
    var intl = (0,useIntl/* default */.Z)();
    var device = (0,useDevice/* useDevice */.F)().device;
    var RateComponent = rates[paymentPolicy];
    var RatePaymentComponent = ratesPaymentDescription[paymentPolicy];
    var RateCancellationComponent = ratesCancellationDescription[paymentPolicy];
    var rateProps = {
        cancellation: cancellation[0],
        currency: currency,
        payRate: payRate
    };
    var showMobileOnlyPrice = isMobile && device !== types_device/* Devices.Desktop */.u.Desktop;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (OfferConditions_styles_module_default()).offerConditionsContainer,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                className: (OfferConditions_styles_module_default()).offerConditionsList,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        className: classnames_default()((OfferConditions_styles_module_default()).textWithIcon, (0,_define_property/* default */.Z)({}, (OfferConditions_styles_module_default()).greenText, code !== ROOM_ONLY_CODE)),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(src/* BottomSheet */.R1, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(src/* BottomSheet.Trigger */.R1.Trigger, {
                                        className: (OfferConditions_styles_module_default()).boardInfoButton,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BoardIcon/* default */.Z, {
                                                code: code
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Board_BoardName, {
                                                code: code,
                                                name: name
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoButton/* default */.Z, {})
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* BottomSheet.Content */.R1.Content, {
                                        title: intl.formatMessage({
                                            id: "policies.rate-conditions"
                                        }),
                                        size: "s",
                                        modalOnDesktop: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (OfferConditions_styles_module_default()).detailContainer,
                                            children: [
                                                code !== ROOM_ONLY_CODE ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                            className: (OfferConditions_styles_module_default()).detailTitle,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Board_BoardName, {
                                                                code: code,
                                                                name: ""
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Board_BoardDescription, {
                                                                code: code
                                                            })
                                                        })
                                                    ]
                                                }) : null,
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                    className: (OfferConditions_styles_module_default()).detailTitle,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                        children: intl.formatMessage({
                                                            id: "global.payment"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(RatePaymentComponent, (0,_object_spread/* default */.Z)({}, rateProps)),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                    className: (OfferConditions_styles_module_default()).detailTitle,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                        children: intl.formatMessage({
                                                            id: "global.cancellation-policies"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(RateCancellationComponent, (0,_object_spread/* default */.Z)({}, rateProps))
                                            ]
                                        })
                                    })
                                ]
                            }),
                            getBestPropertyTag(paymentPolicy, bestPrice, intl)
                        ]
                    }),
                    showMobileOnlyPrice && /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MobilePhone/* default */.Z, {
                                size: 16
                            }),
                            intl.formatMessage({
                                id: "global.mobile-only-price"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RateComponent, (0,_object_spread/* default */.Z)({}, rateProps))
                ]
            })
        })
    });
};
/* harmony default export */ var OfferResponsive_OfferConditions = (OfferConditions);


/***/ }),

/***/ 85536:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _createSvgIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88121);



/* harmony default export */ __webpack_exports__["Z"] = ((0,_createSvgIcon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6663 1.49967C13.6663 1.09967 13.3997 0.833008 12.9997 0.833008C10.333 0.833008 7.33301 2.63301 5.13301 4.29967C4.19967 3.76634 2.26634 3.29967 0.533008 5.03301C0.399674 5.16634 0.333008 5.36634 0.333008 5.56634C0.333008 5.76634 0.466341 5.96634 0.666341 6.03301L1.99967 6.89967L1.86634 7.03301C1.59967 7.29967 1.59967 7.69967 1.86634 7.96634L3.73301 9.83301C3.59967 10.0997 3.59967 10.3663 3.86634 10.633C3.99967 10.7663 4.13301 10.833 4.33301 10.833C4.39967 10.833 4.44967 10.8163 4.49967 10.7997C4.54967 10.783 4.59967 10.7663 4.66634 10.7663L6.53301 12.633C6.66634 12.7663 6.79967 12.833 6.99967 12.833C7.19967 12.833 7.33301 12.7663 7.46634 12.633L7.53301 12.5663L8.39968 13.8997C8.53301 14.033 8.66634 14.1663 8.86634 14.1663H8.93301C9.13301 14.1663 9.26634 14.0997 9.39968 13.9663C11.133 12.233 10.6663 10.2997 10.133 9.36634C11.8663 7.16634 13.6663 4.16634 13.6663 1.49967ZM2.93301 5.96634L2.13301 5.43301C2.73301 5.09967 3.26634 5.09967 3.66634 5.16634L2.93301 5.96634ZM9.06634 12.3663L8.53301 11.5663L9.33301 10.7663C9.39968 11.233 9.39968 11.7663 9.06634 12.3663ZM6.99967 11.233L5.59967 9.83301L7.46634 7.96634C7.73301 7.69967 7.73301 7.29967 7.46634 7.03301C7.19967 6.76634 6.79967 6.76634 6.53301 7.03301L4.66634 8.89968L3.26634 7.49967C4.66634 6.23301 8.79967 2.63301 12.2663 2.23301C11.7997 5.69967 8.26634 9.83301 6.99967 11.233ZM2.13301 9.69967C1.86634 9.43301 1.46634 9.43301 1.19967 9.69967C0.933008 9.96634 0.933008 10.3663 1.19967 10.633L3.86634 13.2997C3.99967 13.433 4.13301 13.4997 4.33301 13.4997C4.53301 13.4997 4.66634 13.433 4.79967 13.2997C5.06634 13.033 5.06634 12.633 4.79967 12.3663L2.13301 9.69967ZM0.533008 11.6997C0.799674 11.433 1.19967 11.433 1.46634 11.6997L2.79967 13.033C3.06634 13.2997 3.06634 13.6997 2.79967 13.9663C2.66634 14.0997 2.53301 14.1663 2.33301 14.1663C2.13301 14.1663 1.99967 14.0997 1.86634 13.9663L0.533008 12.633C0.266341 12.3663 0.266341 11.9663 0.533008 11.6997Z"
}), "Rocket", 16, 16));


/***/ }),

/***/ 38043:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "x": function() { return /* binding */ affiliateHasLogo; }
});

;// CONCATENATED MODULE: ./src/comps/Affiliate/constants.js
var AFFILIATES_LOGOS = [
    "cozycozy",
    "gha",
    "hotelscan",
    "neredekal",
    "skyscanner",
    "tripadvisor",
    "trivago",
    "wego",
    "vio",
    "findhotel",
    "idealo", 
];

;// CONCATENATED MODULE: ./src/comps/Affiliate/functions.js

function affiliateHasLogo(affiliateId) {
    return affiliateId && AFFILIATES_LOGOS.includes(affiliateId);
}


/***/ }),

/***/ 28351:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(83112);
/* harmony import */ var src_constants_environment__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65003);
/* harmony import */ var src_comps_Image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55880);
/* harmony import */ var src_comps_Affiliate_functions__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(38043);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(16058);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_6__);







var Affiliate = function(param) {
    var id = param.id, className = param.className;
    var intl = (0,react_intl__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)();
    if (!(0,src_comps_Affiliate_functions__WEBPACK_IMPORTED_MODULE_5__/* .affiliateHasLogo */ .x)(id)) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "".concat((_styles_module_css__WEBPACK_IMPORTED_MODULE_6___default().affiliateBase), " ").concat(className),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                children: intl.formatMessage({
                    id: "global.found-on"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_comps_Image__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                alt: "".concat(id, "-logo"),
                layout: "cover",
                src: "".concat(src_constants_environment__WEBPACK_IMPORTED_MODULE_2__/* .PATH_IMAGES_CDN */ .VZ, "/affiliates/160524-aid-").concat(id, ".svg")
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Affiliate);


/***/ }),

/***/ 31786:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MT": function() { return /* binding */ MAX_ALLOWED_THUMBNAILS; },
/* harmony export */   "dt": function() { return /* binding */ thumbnailImageSizes; }
/* harmony export */ });
/* unused harmony export MAX_OPTIMIZED_SLIDE_IMG */
var MAX_ALLOWED_THUMBNAILS = 5;
var MAX_OPTIMIZED_SLIDE_IMG = 20;
var thumbnailImageSizes = {
    desktop: {
        size: "204px",
        srcWidth: 204
    },
    tablet: {
        size: "157px",
        srcWidth: 157
    },
    mobile: {
        size: "100vw",
        srcWidth: 767
    }
};


/***/ }),

/***/ 68795:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Am": function() { return /* binding */ getResponsiveImgProps; },
/* harmony export */   "FQ": function() { return /* binding */ getThumbnailsToShow; },
/* harmony export */   "bc": function() { return /* binding */ DEVICE_PHOTOS_INFO; }
/* harmony export */ });
/* unused harmony exports getImage, getImageForSize, ImageSrcType */
/* harmony import */ var src_helpers_imageHandler__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35267);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31786);


function getImage(currentSlide, thumbnails) {
    var ref;
    return (ref = thumbnails[currentSlide]) === null || ref === void 0 ? void 0 : ref.replace(/\/thumb\/|\/medium\//g, "/big/");
}
function getImageForSize(image, size) {
    return image.replace(/\/medium\//g, "/".concat(size, "/"));
}
var DEVICE_PHOTOS_INFO = {
    mobile: {
        indexOfPhotoToLazy: 3,
        photoSize: "medium",
        avgPhotoHeight: 235
    },
    tablet: {
        indexOfPhotoToLazy: 4,
        photoSize: "big",
        avgPhotoHeight: 450
    },
    desktop: {
        indexOfPhotoToLazy: 6,
        photoSize: "big",
        avgPhotoHeight: 320
    }
};
var ImageSrcType;
(function(ImageSrcType) {
    ImageSrcType[ImageSrcType["Responsive"] = 0] = "Responsive";
    ImageSrcType[ImageSrcType["Default"] = 1] = "Default";
})(ImageSrcType || (ImageSrcType = {}));
var getResponsiveImgProps = function(img, sizes) {
    var ref, ref1, ref2, ref3;
    return {
        src: src_helpers_imageHandler__WEBPACK_IMPORTED_MODULE_0__/* .imageHandler.renderSrc */ .J2.renderSrc({
            imgObj: img,
            width: sizes.mobile.srcWidth
        }),
        srcSet: src_helpers_imageHandler__WEBPACK_IMPORTED_MODULE_0__/* .imageHandler.renderSrcSet */ .J2.renderSrcSet(img, sizes === null || sizes === void 0 ? void 0 : (ref = sizes.desktop) === null || ref === void 0 ? void 0 : ref.srcWidth, sizes === null || sizes === void 0 ? void 0 : (ref1 = sizes.tablet) === null || ref1 === void 0 ? void 0 : ref1.srcWidth, sizes.mobile.srcWidth),
        sizes: src_helpers_imageHandler__WEBPACK_IMPORTED_MODULE_0__/* .imageHandler.renderSizes */ .J2.renderSizes({
            desktop: sizes === null || sizes === void 0 ? void 0 : (ref2 = sizes.desktop) === null || ref2 === void 0 ? void 0 : ref2.size,
            tablet: sizes === null || sizes === void 0 ? void 0 : (ref3 = sizes.tablet) === null || ref3 === void 0 ? void 0 : ref3.size,
            mobile: sizes.mobile.size
        })
    };
};
var getThumbnailsToShow = function(isMobile, isTablet, photos) {
    if (isMobile) return photos;
    if (isTablet) return photos.slice(0, _constants__WEBPACK_IMPORTED_MODULE_1__/* .MAX_ALLOWED_THUMBNAILS */ .MT - 2);
    return photos.slice(0, _constants__WEBPACK_IMPORTED_MODULE_1__/* .MAX_ALLOWED_THUMBNAILS */ .MT);
};


/***/ }),

/***/ 42877:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ ONE_KILOMETER_IN_MILES; }
/* harmony export */ });
/* unused harmony export ONE_MILE_IN_KILOMETERS */
var ONE_KILOMETER_IN_MILES = 0.6213711922;
var ONE_MILE_IN_KILOMETERS = 1.609344;


/***/ }),

/***/ 83310:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ getPriceAndRoomType; },
/* harmony export */   "h": function() { return /* binding */ usePrices; }
/* harmony export */ });
/* harmony import */ var src_hooks_useMarket__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59806);
/* harmony import */ var src_hooks_useBusiness__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16153);
/* harmony import */ var src_pages_middleware_defaultAffiliate__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96004);
/* harmony import */ var src_types_prices__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55806);
/* harmony import */ var src_constants_affiliates__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1620);





var countriesToShowNightNetPrices = [
    "us",
    "ca"
];
var countriesToShowAllInPrices = [
    "co",
    "mx",
    "br"
];
var countriesToShowAllInDailyPrices = [
    "au"
];
var countriesToShowAllInKayak = new Set([
    "it",
    "nl",
    "pt",
    "uk",
    "es",
    "ca"
]);
var countriesToShowNetWithFeesInKayak = new Set([
    "us"
]);
var getRoomType = function(rooms) {
    // onnly one room
    if (rooms.length === 1) {
        return src_types_prices__WEBPACK_IMPORTED_MODULE_2__/* .RoomTypes.Single */ .S.Single;
    }
    // all rooms have the same number of adults and children with the same age
    if (rooms.every(function(room) {
        return room.adults === rooms[0].adults && room.children.length === rooms[0].children.length && room.children.every(function(child, index) {
            return child === rooms[0].children[index];
        });
    })) {
        return src_types_prices__WEBPACK_IMPORTED_MODULE_2__/* .RoomTypes.MultiRoom */ .S.MultiRoom;
    }
    // some rooms have different number of adults or children
    return src_types_prices__WEBPACK_IMPORTED_MODULE_2__/* .RoomTypes.MultiBooking */ .S.MultiBooking;
};
var getPriceAndRoomType = function(param) {
    var affiliate = param.affiliate, market = param.market, rateModel = param.rateModel, roomType = param.roomType;
    if (rateModel) {
        return {
            priceType: rateModel,
            roomType: roomType
        };
    }
    if (affiliate === src_pages_middleware_defaultAffiliate__WEBPACK_IMPORTED_MODULE_4__/* .DEFAULT_AFFILIATE_ID */ ._) {
        var countryAffiliatePriceFormat = {
            us: src_types_prices__WEBPACK_IMPORTED_MODULE_2__/* .PriceType.AllIn */ .F.AllIn
        };
        if (countryAffiliatePriceFormat === null || countryAffiliatePriceFormat === void 0 ? void 0 : countryAffiliatePriceFormat[market]) {
            return {
                priceType: countryAffiliatePriceFormat[market],
                roomType: roomType
            };
        }
    }
    if (affiliate === src_constants_affiliates__WEBPACK_IMPORTED_MODULE_3__/* .AFFILIATE_TRIVAGO */ .i0) {
        var countryAffiliatePriceFormat1 = {
            us: src_types_prices__WEBPACK_IMPORTED_MODULE_2__/* .PriceType.NetWithFeesDaily */ .F.NetWithFeesDaily,
            ca: src_types_prices__WEBPACK_IMPORTED_MODULE_2__/* .PriceType.NetWithFeesDaily */ .F.NetWithFeesDaily,
            br: src_types_prices__WEBPACK_IMPORTED_MODULE_2__/* .PriceType.TrivagoNet */ .F.TrivagoNet,
            mx: src_types_prices__WEBPACK_IMPORTED_MODULE_2__/* .PriceType.TrivagoNet */ .F.TrivagoNet,
            za: src_types_prices__WEBPACK_IMPORTED_MODULE_2__/* .PriceType.Gross */ .F.Gross
        };
        var _market;
        return {
            priceType: (_market = countryAffiliatePriceFormat1[market]) !== null && _market !== void 0 ? _market : src_types_prices__WEBPACK_IMPORTED_MODULE_2__/* .PriceType.AllIn */ .F.AllIn,
            roomType: roomType
        };
    }
    if (affiliate === src_constants_affiliates__WEBPACK_IMPORTED_MODULE_3__/* .AFFILIATE_TRIPADVISOR */ .Du) {
        var countryAffiliatePriceFormat2 = {
            us: src_types_prices__WEBPACK_IMPORTED_MODULE_2__/* .PriceType.NetWithFeesDaily */ .F.NetWithFeesDaily,
            ca: src_types_prices__WEBPACK_IMPORTED_MODULE_2__/* .PriceType.NetWithFeesDaily */ .F.NetWithFeesDaily,
            fr: src_types_prices__WEBPACK_IMPORTED_MODULE_2__/* .PriceType.AllIn */ .F.AllIn,
            au: src_types_prices__WEBPACK_IMPORTED_MODULE_2__/* .PriceType.AllIn */ .F.AllIn,
            br: src_types_prices__WEBPACK_IMPORTED_MODULE_2__/* .PriceType.TrivagoNet */ .F.TrivagoNet,
            mx: src_types_prices__WEBPACK_IMPORTED_MODULE_2__/* .PriceType.TrivagoNet */ .F.TrivagoNet
        };
        var _market1;
        return {
            priceType: (_market1 = countryAffiliatePriceFormat2[market]) !== null && _market1 !== void 0 ? _market1 : src_types_prices__WEBPACK_IMPORTED_MODULE_2__/* .PriceType.AllInDaily */ .F.AllInDaily,
            roomType: roomType
        };
    }
    if (affiliate === src_constants_affiliates__WEBPACK_IMPORTED_MODULE_3__/* .AFFILIATE_GHA */ .vt) {
        var countryAffiliatePriceFormat3 = {
            us: src_types_prices__WEBPACK_IMPORTED_MODULE_2__/* .PriceType.NetWithFeesDaily */ .F.NetWithFeesDaily,
            ca: src_types_prices__WEBPACK_IMPORTED_MODULE_2__/* .PriceType.NetWithFeesDaily */ .F.NetWithFeesDaily
        };
        var _market2;
        return {
            priceType: (_market2 = countryAffiliatePriceFormat3[market]) !== null && _market2 !== void 0 ? _market2 : src_types_prices__WEBPACK_IMPORTED_MODULE_2__/* .PriceType.AllInDaily */ .F.AllInDaily,
            roomType: roomType
        };
    }
    if ([
        src_constants_affiliates__WEBPACK_IMPORTED_MODULE_3__/* .AFFILIATE_FINDHOTEL */ .t4,
        src_constants_affiliates__WEBPACK_IMPORTED_MODULE_3__/* .AFFILIATE_VIO */ .hS,
        src_constants_affiliates__WEBPACK_IMPORTED_MODULE_3__/* .AFFILIATE_SKYSCANNER */ .bO
    ].includes(affiliate)) {
        return {
            priceType: src_types_prices__WEBPACK_IMPORTED_MODULE_2__/* .PriceType.AllInDaily */ .F.AllInDaily,
            roomType: roomType
        };
    }
    if ([
        src_constants_affiliates__WEBPACK_IMPORTED_MODULE_3__/* .AFFILIATE_HOTELSCAN */ .uz,
        src_constants_affiliates__WEBPACK_IMPORTED_MODULE_3__/* .AFFILIATE_IDEALO */ .yb
    ].includes(affiliate)) {
        if ([
            "mx",
            "br"
        ].includes(market)) {
            return {
                priceType: src_types_prices__WEBPACK_IMPORTED_MODULE_2__/* .PriceType.Gross */ .F.Gross,
                roomType: roomType
            };
        }
    }
    if (affiliate === src_constants_affiliates__WEBPACK_IMPORTED_MODULE_3__/* .AFFILIATE_KAYAK */ .re) {
        if (countriesToShowAllInKayak.has(market)) {
            return {
                priceType: src_types_prices__WEBPACK_IMPORTED_MODULE_2__/* .PriceType.AllIn */ .F.AllIn,
                roomType: roomType
            };
        }
        if (countriesToShowNetWithFeesInKayak.has(market)) {
            return {
                priceType: src_types_prices__WEBPACK_IMPORTED_MODULE_2__/* .PriceType.NetWithFees */ .F.NetWithFees,
                roomType: roomType
            };
        }
    }
    var showNightNetPrice = countriesToShowNightNetPrices.includes(market);
    if (showNightNetPrice) {
        return {
            priceType: src_types_prices__WEBPACK_IMPORTED_MODULE_2__/* .PriceType.Net */ .F.Net,
            roomType: roomType
        };
    }
    var showAllInPrice = countriesToShowAllInPrices.includes(market);
    if (showAllInPrice) {
        return {
            priceType: src_types_prices__WEBPACK_IMPORTED_MODULE_2__/* .PriceType.AllIn */ .F.AllIn,
            roomType: roomType
        };
    }
    var showAllInDailyPrice = countriesToShowAllInDailyPrices.includes(market);
    if (showAllInDailyPrice) {
        return {
            priceType: src_types_prices__WEBPACK_IMPORTED_MODULE_2__/* .PriceType.AllInDaily */ .F.AllInDaily,
            roomType: roomType
        };
    }
    return {
        priceType: src_types_prices__WEBPACK_IMPORTED_MODULE_2__/* .PriceType.Gross */ .F.Gross,
        roomType: roomType
    };
};
function usePrices(param) {
    var rooms = param.rooms;
    var market = (0,src_hooks_useMarket__WEBPACK_IMPORTED_MODULE_0__/* .useMarket */ .A)().market;
    var ref = (0,src_hooks_useBusiness__WEBPACK_IMPORTED_MODULE_1__/* .useBusiness */ .i)(), affiliate = ref.affiliate, rateModel = ref.rateModel;
    var checkedRatedModel = rateModel && Object.values(src_types_prices__WEBPACK_IMPORTED_MODULE_2__/* .PriceType */ .F).includes(rateModel) ? rateModel : null;
    var roomType = getRoomType(rooms);
    return getPriceAndRoomType({
        market: market,
        affiliate: affiliate,
        rateModel: checkedRatedModel,
        roomType: roomType
    });
}


/***/ }),

/***/ 55806:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ PriceType; },
/* harmony export */   "S": function() { return /* binding */ RoomTypes; }
/* harmony export */ });
var PriceType;
(function(PriceType) {
    PriceType["AllIn"] = "all_in";
    PriceType["AllInDaily"] = "all_in_daily";
    PriceType["Net"] = "net";
    PriceType["Gross"] = "gross";
    PriceType["TrivagoNet"] = "trivago_net";
    PriceType["NetWithFees"] = "net_with_fees";
    PriceType["NetWithFeesDaily"] = "net_with_fees_daily";
})(PriceType || (PriceType = {}));
var RoomTypes;
(function(RoomTypes) {
    RoomTypes["Single"] = "single";
    RoomTypes["MultiRoom"] = "multiroom";
    RoomTypes["MultiBooking"] = "multibooking";
})(RoomTypes || (RoomTypes = {}));


/***/ }),

/***/ 51800:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "rA": function() { return /* binding */ MEASUREMENT_UNITS; }
/* harmony export */ });
/* unused harmony exports MEASUREMENT_SYSTEMS, IMPERIAL_MARKETS, MeasurementSystemValidation, MeasurementSystem */
/* harmony import */ var zod__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53538);
/* harmony import */ var _datasource_CountryDatasource__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(16764);







var MEASUREMENT_SYSTEMS = [
    "metric",
    "imperial"
];
var MEASUREMENT_UNITS = {
    METRIC: "metric",
    IMPERIAL: "imperial"
};
var IMPERIAL_MARKETS = Array.from(new Set(Object.values(_datasource_CountryDatasource__WEBPACK_IMPORTED_MODULE_0__/* .countryDataSource */ .yu).filter(function(config) {
    return config.measurementSystem === MEASUREMENT_UNITS.IMPERIAL;
}).map(function(config) {
    return config.market;
})));
var MeasurementSystemValidation = zod__WEBPACK_IMPORTED_MODULE_1__/* .object */ .Ry({
    value: zod__WEBPACK_IMPORTED_MODULE_1__/* ["enum"] */ .Km(MEASUREMENT_SYSTEMS, {
        required_error: "[MeasurementSystem] value is required"
    })
});
var MeasurementSystem = /*#__PURE__*/ (/* unused pure expression or super */ null && (function(Model) {
    "use strict";
    _inherits(MeasurementSystem, Model);
    var _super = _create_super(MeasurementSystem);
    function MeasurementSystem(_value) {
        _class_call_check(this, MeasurementSystem);
        var _this;
        _this = _super.call(this);
        _this._value = _value;
        return _this;
    }
    var _proto = MeasurementSystem.prototype;
    _proto.isMetric = function isMetric() {
        return this._value === "metric";
    };
    _proto.isImperial = function isImperial() {
        return this._value === "imperial";
    };
    _proto.toJSON = function toJSON() {
        return {
            value: this._value
        };
    };
    MeasurementSystem.create = function create(param) {
        var value = param.value;
        MeasurementSystemValidation.parse({
            value: value
        });
        return new MeasurementSystem(value);
    };
    MeasurementSystem.metric = function metric() {
        return new MeasurementSystem("metric");
    };
    MeasurementSystem.imperial = function imperial() {
        return new MeasurementSystem("imperial");
    };
    MeasurementSystem.fromJSON = function fromJSON(json) {
        return MeasurementSystem.create({
            value: json.value
        });
    };
    _create_class(MeasurementSystem, [
        {
            key: "value",
            get: function get() {
                return this._value;
            } // prettier-ignore
        }
    ]);
    return MeasurementSystem;
}(Model)));


/***/ }),

/***/ 74890:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"bestPropertyTag":"styles_bestPropertyTag__E0wVP system_captionL__E1FNu","branded":"styles_branded__f8aff"};

/***/ }),

/***/ 16126:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"info":"styles_info__N4Irh system_resetButton__nOoOv"};

/***/ }),

/***/ 16058:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"affiliateBase":"styles_affiliateBase__Fpqqd"};

/***/ })

}]);